import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useServices } from 'hooks/useServices';
import { usePartnerManager } from 'hooks/usePartnerManager';
import { useSafeAsyncWrapper } from './useSafeAsyncWrapper';

export const usePartnerManagerDataProcess = (partnerId: number): void => {
  const dispatch = useAppDispatcher();

  const { getPartnerManagerData } = useServices();

  const { dataInvalidated } = usePartnerManager();

  const wrapAsyncSafely = useSafeAsyncWrapper();

  React.useLayoutEffect(() => {
    if (dataInvalidated) {
      const promise = getPartnerManagerData(partnerId).then((data) => {
        dispatch({
          name: 'PartnerManager__DataRecieved',
          data,
        });
      });

      wrapAsyncSafely(promise);
    }
  }, [
    dataInvalidated,
    dispatch,
    getPartnerManagerData,
    partnerId,
    wrapAsyncSafely,
  ]);
};
